<template>
  <router-link v-if="mainLink" class="text-decoration-none" :to="{ name: 'main' }">
    <p class="logo__text" :class="bindClass" :style="fontSize">#BUY NOW</p>
  </router-link>
  <p v-else class="logo__text" :class="bindClass" :style="fontSize">#BUY NOW</p>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '28px',
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
    white: {
      type: Boolean,
      default: false,
    },
    mainLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fontSize() {
      const size = this.size
      return {
        fontSize: size + '!important',
        fontWeight: '900 !important',
      }
    },
    bindClass() {
      let color = ['color--nice']
      if (this.white) {
        color = ['color--white']
      }
      return [...this.classes, ...color, 'my-0']
    },
  },
}
</script>

<style lang="scss" scoped>
.logo__text {
  line-height: 1;
}
</style>
